import { useState } from 'react';
import { stats, faqItems, testimonials } from '@/mocks/data';

export default function TrustSection() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const toggleFaq = (idx: number) => {
    setOpenFaq(openFaq === idx ? null : idx);
  };

  return (
    <>
      <section className="py-16 md:py-20 bg-background-100/60">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {stats.map((stat, idx) => (
              <div key={idx} className="text-center p-6 rounded-lg bg-background-50 border border-background-200/50">
                <div className="text-2xl md:text-3xl font-bold font-heading text-primary-500 mb-1">
                  {stat.value}
                </div>
                <div className="text-sm text-foreground-600">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
              用户<strong className="text-secondary-500">好评</strong>
            </h2>
            <p className="text-foreground-600 text-sm max-w-xl mx-auto">
              听听我们的用户怎么说
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {testimonials.map((item, idx) => (
              <div
                key={idx}
                className="p-6 rounded-lg bg-background-100/70 border border-background-200/50"
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                    <img src={item.avatar} alt={item.name} className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-foreground-900">{item.name}</div>
                    <div className="text-xs text-foreground-500">{item.role}</div>
                  </div>
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed">{item.content}</p>
                <div className="flex items-center gap-1 mt-3">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-xs text-primary-400" />
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-background-100/60">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
              常见<strong className="text-accent-500">问题</strong>
            </h2>
            <p className="text-foreground-600 text-sm">快速解答您的疑问</p>
          </div>

          <div className="space-y-3">
            {faqItems.map((item, idx) => (
              <div
                key={idx}
                className="rounded-lg border border-background-200/60 bg-background-50 overflow-hidden"
              >
                <button
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                  onClick={() => toggleFaq(idx)}
                  aria-expanded={openFaq === idx}
                >
                  <span className="text-sm font-medium text-foreground-900 pr-4">{item.question}</span>
                  <i
                    className={`text-foreground-500 text-lg flex-shrink-0 transition-transform duration-200 ${
                      openFaq === idx ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  />
                </button>
                {openFaq === idx && (
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}